import Vue from 'vue'
import Router from 'vue-router'

import Swagger from '@/components/swagger/swagger-component'
import Detail from '@/components/detail/detail-component'
import Home from '@/components/home/home-component'
import NotFound from '@/components/404/404-component'
import Login from '@/components/login/login-component'
import Profile from '@/components/profile/profile-component'
import ErrorPage from '@/components/error/error-component'

import store from '../store'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/swagger',
      name: 'swagger',
      component: Swagger
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '/error/:errorCode',
      name: 'error',
      component: ErrorPage
    }
  ],
  mode: 'history'
})

/**
 * Check if User has logged in before.
 * @return {getters.getAccessToken|getters.getRefreshToken|getters.getExpiresIn}
 */
function isUserLoggedIn () {
  console.log('=> isUserLoggedIn')
  const res = (store.getters.getAccessToken &&
    store.getters.getRefreshToken &&
    store.getters.getExpiresIn &&
    store.getters.getStateToken)
  return res
}

router.beforeEach((to, from, next) => {
  console.log('=> router.beforeEach. to: ' + to.name + ', from: ' + from.name)
  if (to.name === 'login' || isUserLoggedIn()) {
    next() // move on to the next hook in the pipeline. If no hooks are left, the navigation is confirmed.
  } else {
    next('/') // init app: redirect to login.
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js